module.exports = __webpack_public_path__ + "img/spinner-large.a9c91f2a.svg";